






























































import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Ringkasan supervisi naratif — tanpa skoring ya/tidak ×100 (audit yang
 * tetap memakai skor; supervisi berbentuk kata-kata per feedback tim PPI).
 */
@Component
export default class SupervisiUmumRingkasanPanel extends Vue {
  @Prop({ required: true }) items!: any[];
  @Prop({ required: true }) form!: any;
  @Prop({ default: () => [] }) seksiList!: any[];

  get itemsTemuan() {
    return this.items.filter((i: any) => i.masalah && String(i.masalah).trim() !== "");
  }

  updateField(field: string, value: any) {
    this.$emit("update:form", { ...this.form, [field]: value });
  }
}
